import { resolveAssetWatchCognitoConfig } from "@assetwatch/auth";

const cognito = resolveAssetWatchCognitoConfig({
  allowFallback: import.meta.env.DEV,
  deployEnvironment: import.meta.env.VITE_DEPLOY_ENVIRONMENT,
  injectedConfig: {
    USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
    IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
    DOMAIN: import.meta.env.VITE_COGNITO_DOMAIN,
  },
});

export default {
  appName: "Field Ops",
  cognito: {
    USER_POOL_ID: cognito.USER_POOL_ID,
    APP_CLIENT_ID: cognito.APP_CLIENT_ID,
    IDENTITY_POOL_ID: cognito.IDENTITY_POOL_ID,
    DOMAIN: cognito.DOMAIN,
  },
};
